import { render, staticRenderFns } from "./FormSendMessage.vue?vue&type=template&id=7d3e5fa2"
import script from "./FormSendMessage.vue?vue&type=script&lang=js"
export * from "./FormSendMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d3e5fa2')) {
      api.createRecord('7d3e5fa2', component.options)
    } else {
      api.reload('7d3e5fa2', component.options)
    }
    module.hot.accept("./FormSendMessage.vue?vue&type=template&id=7d3e5fa2", function () {
      api.rerender('7d3e5fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/moderation/FormSendMessage.vue"
export default component.exports